module.exports = __webpack_public_path__ + "static/navLogoKvet@2x-e168a7d8e73ea0c616c691ec80e82c2e.png";